import "./intro.f51eab48.js";
import "./intro.c6c16525.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire22ae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire22ae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ayMG0 = parcelRequire("ayMG0");

var $aRPiL = parcelRequire("aRPiL");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7k9bU = parcelRequire("7k9bU");

var $fW63b = parcelRequire("fW63b");

var $lQLQx = parcelRequire("lQLQx");

var $3S1uf = parcelRequire("3S1uf");

function $03de9ed59610e421$var$IntroPage() {
    // const userLang = (navigator.language || navigator.userLanguage) == 'zh-TW' ? 'ch' : 'en'; 
    const userLang = 'en';
    const storedLang = localStorage.getItem('lang');
    const [lang, setLang] = (0, $acw62.useState)(storedLang ?? userLang);
    const [content, setContent] = (0, $acw62.useState)(null);
    function updateLang(lang) {
        setLang(lang);
        localStorage.setItem('lang', lang);
    }
    (0, $acw62.useEffect)(()=>{
        var _;
        fetch(`/api/intro/intro.${lang}.json`).then((res)=>{
            if (res.ok) return res.json();
            throw new Error(`Fetch /api/intro/intro.${lang}.json failed`);
        }).then((json)=>setContent(json)).catch((e)=>console.error(e));
    }, [
        lang
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3S1uf.default).Provider, {
        value: lang,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "content",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7k9bU.ElementRenderer), {
                    active: content != null,
                    contents: content
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fW63b.default), {
                updateLang: updateLang
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lQLQx.default), {})
        ]
    });
}
var $03de9ed59610e421$export$2e2bcd8739ae039 = $03de9ed59610e421$var$IntroPage;


document.body.innerHTML = '<div id="main"></div>';
document.body.className = 'body';
const $57b9a0455d953c58$var$root = (0, $aRPiL.createRoot)(document.getElementById('main'));
$57b9a0455d953c58$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $03de9ed59610e421$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=intro.948b01e3.js.map
